import { React, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Container,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
  Input,
} from "reactstrap";

import FormHelpers from "../helpers/FormHelpers";

import CardPreview from "./Cards/CardPreview";
import EcardPreview from "./Ecards/EcardPreview";
import Card from "./Cards/Card";

import { cardPreviewActions } from "../store/card-preview-slice";

function PreviewArea() {
  const dispatch = useDispatch();

  // overall preview state
  const showCardGallery = useSelector(
    (state) => state.cardPreview.ShowCardGallery
  );

  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  const currentPreviewState = useSelector((state) => state.cardPreview);
  const formStep = useSelector((state) => state.configurator.FormStep);

  const requestDetails = currentRequest.DonorRequest;
  const currentOccasion = currentPreviewState.Occasion;
  const occasionLoading = currentPreviewState.OccasionLoading;
  const isEcardPreview =
    formStep === "Approve" && requestDetails.CardTypeValue === "ecard";

  // zooming and dragging
  const defaultZoom = 0.6;
  const [zoom, setZoom] = useState(defaultZoom);

  const handleZoom = (zoomIn) => {
    setZoom(zoomIn ? zoom + 0.2 : zoom - 0.2);
  };

  const resetZoom = () => {
    setZoom(defaultZoom);
  };

  // toggle more cards modal
  const toggleCardsModal = (e) => {
    dispatch(cardPreviewActions.setShowCardGallery(!showCardGallery));
  };

  const onClickCardHandler = (card) => {
    dispatch(cardPreviewActions.setSelectedCard(card));
    toggleCardsModal();
    resetZoom();
  };

  return (
    <div className="cfg-preview-area-contain">
      <h3>
        <span>Preview</span>
      </h3>
      <div className="cfg-preview-area">
        {occasionLoading && (
          <div className="loading-spinner">
            <Spinner color="primary">Loading...</Spinner>
          </div>
        )}
        {!occasionLoading && (
          <div>
            <div
              className="row cfg-preview-toolbar"
              role="toolbar"
              aria-label="Preview Toolbar"
            >
              <div className="col-6 col-lg-6">
                <button
                  onClick={toggleCardsModal}
                  className="btn btn-primary btn-sm cfg-btn-more-cards"
                >
                  More Cards
                </button>
              </div>
              {!isEcardPreview && (
                <div className="col-6 col-lg-6 text-end">
                  <button
                    onClick={() => handleZoom(true)}
                    className="btn btn-primary btn-sm cfg-btn-zoom-in"
                  >
                    <i className="fa fa-search-plus"></i>
                  </button>{" "}
                  <button
                    onClick={() => handleZoom(false)}
                    className="btn btn-primary btn-sm cfg-btn-zoom-out"
                  >
                    <i className="fa fa-search-minus"></i>
                  </button>
                </div>
              )}
            </div>

            {!isEcardPreview && (
              <CardPreview zoom={zoom} showCard={true} showEnvelope={true} />
            )}
            {isEcardPreview && <EcardPreview />}

            <Modal
              className="gallery"
              isOpen={showCardGallery}
              toggle={toggleCardsModal}
              size="lg"
            >
              <ModalHeader toggle={toggleCardsModal}>Card Gallery</ModalHeader>
              <ModalBody>
                <Container>
                  <Row>
                    {currentOccasion.CardPreviews.map((card) => (
                      <Card
                        key={card.Id}
                        card={card}
                        onCardClick={onClickCardHandler}
                      />
                    ))}
                  </Row>
                </Container>
              </ModalBody>
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
}

export default PreviewArea;
